export const StringKeys = {
    ABOUT: "about",
    ABOUT_COMMUNITY_CONTENT_1: "about_community_content_1",
    ABOUT_COMMUNITY_CONTENT_2: "about_community_content_2",
    ABOUT_COMMUNITY_SECTION: "about_community_section",
    ABOUT_OFFER_AI: "about_offer_ai",
    ABOUT_OFFER_COMMUNITY: "about_offer_community",
    ABOUT_OFFER_COMPREHENSIVE: "about_offer_comprehensive",
    ABOUT_OFFER_INTERFACE: "about_offer_interface",
    ABOUT_OFFER_PRICING: "about_offer_pricing",
    ABOUT_OFFER_SECTION: "about_offer_section",
    ABOUT_STORY_CONTENT: "about_story_content",
    ABOUT_STORY_SECTION: "about_story_section",
    ABOUT_SUBTITLE: "about_subtitle",
    ABOUT_TITLE: "about_title",
    ABOUT_VISION_CONTENT: "about_vision_content",
    ABOUT_VISION_SECTION: "about_vision_section",
    ABOUT_WHY_IMPROVEMENT: "about_why_improvement",
    ABOUT_WHY_SECTION: "about_why_section",
    ABOUT_WHY_SUPPORT: "about_why_support",
    ABOUT_WHY_TAILORED: "about_why_tailored",
    ABOUT_WHY_TECHNOLOGY: "about_why_technology",
    ABOUT_WHY_VALUE: "about_why_value",
    ACH: "ach",
    ACKNOWLEDGED: "acknowledged",
    ACKNOWLEDGED_BY_EMPLOYEE_ON: "acknowledged_by_employee_on",
    ACKNOWLEDGED_BY_MANAGER_ON: "acknowledged_by_manager_on",
    ACTIONS: "actions",
    ACTIVE: "active",
    ACTUAL_REVENUE: "actual_revenue",
    ADDITIONAL_COMMENTS: "additional_comments",
    ADDRESS: "address",
    ADDRESS_IS_REQUIRED: "address_is_required",
    ADD_ASSET: "add_asset",
    ADD_AVAILABILITY_SLOT: "add_availability_slot",
    ADD_A_CUSTOM_QUESTION: "add_a_custom_question",
    ADD_CODE: "add_code",
    ADD_CUSTOMER: "add_customer",
    ADD_DEPARTMENT: "add_department",
    ADD_DOCUMENT: "add_document",
    ADD_EMPLOYEE: "add_employee",
    ADD_EVENT: "add_event",
    ADD_INVENTORY_ITEM: "add_inventory_item",
    ADD_ITEM: "add_item",
    ADD_JOB_CODE: "add_job_code",
    ADD_LINE_ITEM: "add_line_item",
    ADD_LOCATION: "add_location",
    ADD_NEW_IMAGE: "add_new_image",
    ADD_NOTE: "add_note",
    ADD_ORDER: "add_order",
    ADD_ORGANIZATION_LOGO: "add_organization_logo",
    ADD_PRODUCT: "add_product",
    ADD_PRODUCT_CATEGORY: "add_product_category",
    ADD_QUESTION: "add_question",
    ADD_REPLY: "add_reply",
    ADD_ROLE: "add_role",
    ADD_SUPPLIER: "add_supplier",
    ADD_TAX_REGISTRATION: "add_tax_registration",
    ADD_TIME_CLOCK_ENTRY: "add_time_clock_entry",
    ADD_TIME_SLOT: "add_time_slot",
    ADD_TO_GOOGLE_CALENDAR: "add_to_google_calendar",
    ADD_UNIT_OF_MEASURE: "add_unit_of_measure",
    ADD_UOM: "add_uom",
    ADJUST: "adjust",
    ADJUSTMENT: "adjustment",
    ADJUSTMENT_HISTORY: "adjustment_history",
    ADJUSTMENT_TYPE: "adjust_type",
    ADJUST_INVENTORY: "adjust_inventory",
    AGING_ANALYSIS: "aging_analysis",
    AGO: "ago",
    ALL: "all",
    ALL_CATEGORIES: "all_categories",
    ALL_DAY: "all_day",
    ALL_EMPLOYEES: "all_employees",
    ALL_EVENTS: "all_events",
    ALL_POSTS: "all_posts",
    ALREADY_HAVE_AN_ACCOUNT: "already_have_an_account",
    AMOUNT: "amount",
    AMOUNT_DUE: "amount_due",
    AMOUNT_REFUNDED: "amount_refunded",
    AND: "and",
    ANNUAL: "annual",
    APPROVALS: "approvals",
    APPROVE: "approve",
    ARCHIVE: "archive",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS: "are_you_sure_you_want_to_delete_this",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_X: "are_you_sure_you_want_to_delete_x",
    ARE_YOU_SURE_YOU_WANT_TO_GENERATE_A_NEW_DOCUMENT_: "are_you_sure_you_want_to_generate_a_new_document_",
    ARE_YOU_SURE_YOU_WANT_TO_REFUND_THIS_INVOICE: "are_you_sure_you_want_to_refund_this_invoice",
    ARE_YOU_SURE_YOU_WANT_TO_SEND_THIS_INVOICE: "are_you_sure_you_want_to_send_this_invoice",
    ASSET: "asset",
    ASSETS: "assets",
    ASSET_NAME: "asset_name",
    ASSET_NAME_REQUIRED: "asset_name_required",
    ASSIGN_CUSTOMER: "assign_customer",
    ASSIGN_EMPLOYEES: "assign_employees",
    AT_LEAST_ONE_LINE_ITEM_IS_REQUIRED: "at_least_one_line_item_is_required",
    AT_LEAST_ONE_QUESTION_MUST_BE_SELECTED_TO_CREATE_TEMPLATE: "at_least_one_question_must_be_selected_to_create_template",
    AVAILABILITY: "availability",
    AVAILABLE: "available",
    AVAILABLE_TIME_SLOT: "available_time_slot",
    AVERAGE_DAYS_TO_PAY: "average_days_to_pay",
    AVERAGE_INVOICE_AMOUNT: "average_invoice_amount",
    AVERAGE_INVOICE_VALUE: "average_invoice_value",
    BASIC_MODULES: "basic_modules",
    BELOW_EXPECTATIONS: "below_expectations",
    BILLING: "billing",
    BIRTHDAY: "birthday",
    BIZIBOARD: "biziboard",
    BIZIDOCS: "bizidocs",
    BIZIDOCS_DESCRIPTION: "bizidocs_description",
    BLOG: "blog",
    BOTH_REVIEWS_MUST_BE_COMPLETED_BEFORE_ACKNOWLEDGEMENT: "both_reviews_must_be_completed_before_acknowledgement",
    BRANDING: "branding",
    BUG_REPORT: "bug_report",
    BUSINESS_PROPOSAL: "business_proposal",
    BY_CLICKING_LOG_IN_YOU_AGREE_TO_OUR_: "by_clicking_log_in_you_agree_to_our_",
    BY_SIGNING_UP_YOU_AGREE_TO_OUR_: "by_signing_up_you_agree_to_our_",
    CALENDAR: "calendar",
    CAMERA: "camera",
    CANCEL: "cancel",
    CANCELED: "canceled",
    CANNOT_DELETE_A_DEPARTMENT_THAT_CURRENTLY_HAS_EMPLOYEES_ASSIGNED_TO_IT: "cannot_delete_a_department_that_currently_has_employees_assigned_to_it",
    CAPACITY: "capacity",
    CAPACITY_MUST_BE_A_NON_NEGATIVE_INTEGER: "capacity_must_be_a_non_negative_integer",
    CAROUSEL_CARD_1_DESCRIPTION: "carousel_card_1_description",
    CAROUSEL_CARD_1_HEADER: "carousel_card_1_header",
    CAROUSEL_CARD_2_DESCRIPTION: "carousel_card_2_description",
    CAROUSEL_CARD_2_HEADER: "carousel_card_2_header",
    CAROUSEL_CARD_3_DESCRIPTION: "carousel_card_3_description",
    CAROUSEL_CARD_3_HEADER: "carousel_card_3_header",
    CAROUSEL_CARD_4_DESCRIPTION: "carousel_card_4_description",
    CAROUSEL_CARD_4_HEADER: "carousel_card_4_header",
    CATEGORY: "category",
    CHANGE_PROFILE_PICTURE: "change_profile_picture",
    CITY: "city",
    CITY_IS_REQUIRED: "city_is_required",
    CLIENTS: "clients",
    CLIENT_INFORMATION: "client_information",
    CLOCK_IN: "clock_in",
    CLOCK_IN_TIME: "clock_in_time",
    CLOCK_IN_TIME_REQUIRED: "clock_in_time_required",
    CLOCK_OUT: "clock_out",
    CLOCK_OUT_BEFORE_CLOCK_IN: "clock_out_before_clock_in",
    CLOCK_OUT_MUST_BE_AFTER_CLOCK_IN: "clock_out_must_be_after_clock_in",
    CLOCK_OUT_TIME: "clock_out_time",
    CLOCK_OUT_TIME_REQUIRED: "clock_out_time_required",
    CLOSE: "close",
    CODE: "code",
    COMMENTS: "comments",
    COMMUNITY_BOARD: "community_board",
    COMPANY: "company",
    COMPANY_DOCUMENTS: "company_documents",
    COMPANY_NAME: "company_name",
    COMPANY_NAME_IS_REQUIRED: "company_name_is_required",
    COMPLETE_YOUR_ACCOUNT_SETUP: "complete_your_account_setup",
    CONDITION: "condition",
    CONFIGURE_TAX_SETTINGS: "configure_tax_settings",
    CONFIRM: "confirm",
    CONFIRM_ACTION: "confirm_action",
    CONFIRM_REFUND: "confirm_refund",
    CONFIRM_SEND: "confirm_send",
    CONNECT: "connect",
    CONNECT_TO_SYNC_YOUR_EVENTS_WITH_GOOGLE_CALENDAR: "connect_to_sync_your_events_with_google_calendar",
    CONTACT: "contact",
    CONTENT: "content",
    CONTENT_IS_REQUIRED: "content_is_required",
    CONTROVERSIAL: "controversial",
    COOKIE_POLICY: "cookie_policy",
    COOKIE_POLICY_CHANGES_CONTENT: "cookie_policy_changes_content",
    COOKIE_POLICY_CHANGES_SECTION: "cookie_policy_changes_section",
    COOKIE_POLICY_CONTACT_EMAIL: "cookie_policy_contact_email",
    COOKIE_POLICY_CONTACT_PHONE: "cookie_policy_contact_phone",
    COOKIE_POLICY_CONTACT_SECTION: "cookie_policy_contact_section",
    COOKIE_POLICY_EFFECTIVE_DATE: "cookie_policy_effective_date",
    COOKIE_POLICY_FIRST_PARTY_CONTENT: "cookie_policy_first_party_content",
    COOKIE_POLICY_FIRST_PARTY_SECTION: "cookie_policy_first_party_section",
    COOKIE_POLICY_INTRO_CONTENT: "cookie_policy_intro_content",
    COOKIE_POLICY_INTRO_SECTION: "cookie_policy_intro_section",
    COOKIE_POLICY_MANAGING_CONTENT: "cookie_policy_managing_content",
    COOKIE_POLICY_MANAGING_NOTE: "cookie_policy_managing_note",
    COOKIE_POLICY_MANAGING_SECTION: "cookie_policy_managing_section",
    COOKIE_POLICY_PERSISTENT_CONTENT: "cookie_policy_persistent_content",
    COOKIE_POLICY_PERSISTENT_SECTION: "cookie_policy_persistent_section",
    COOKIE_POLICY_SESSION_CONTENT: "cookie_policy_session_content",
    COOKIE_POLICY_SESSION_SECTION: "cookie_policy_session_section",
    COOKIE_POLICY_THIRD_PARTY_CONTENT: "cookie_policy_third_party_content",
    COOKIE_POLICY_THIRD_PARTY_SECTION: "cookie_policy_third_party_section",
    COOKIE_POLICY_TYPES_SECTION: "cookie_policy_types_section",
    COOKIE_POLICY_USAGE_CONTENT: "cookie_policy_usage_content",
    COOKIE_POLICY_USAGE_LIST: "cookie_policy_usage_list",
    COOKIE_POLICY_USAGE_SECTION: "cookie_policy_usage_section",
    COPIED: "copied",
    COPY_INVOICE_PAYMENT_LINK: "copy_invoice_payment_link",
    COST: "cost",
    CREATED_BY: "created_by",
    CREATED_DATE: "created_date",
    CREATE_A_DOCUMENT_FOR_ORGANIZATION: "create_a_document_for_organization",
    CREATE_INVOICE: "create_invoice",
    CREATE_NEW_INVOICE: "create_new_invoice",
    CREATE_POST: "create_post",
    CREATE_PRODUCT: "create_product",
    CREATE_REVIEW_TEMPLATE: "create_review_template",
    CREATE_YOUR_ACCOUNT: "create_your_account",
    CREDIT_CARD: "credit_card",
    CURRENT: "current",
    CURRENTLY_CLOCKED_IN: "currently_clocked_in",
    CURRENT_PERIOD_END: "current_period_end",
    CUSTOMER: "customer",
    CUSTOMERS: "customers",
    CUSTOMER_FEEDBACK_FORM: "customer_feedback_form",
    CUSTOMER_ID: "customer_id",
    CUSTOMER_ORDER: "customer_order",
    CUSTOMIZE_INVOICES: "customize_invoices",
    CUSTOM_QUESTION: "custom_question",
    DAILY: "daily",
    DAMAGED_GOODS: "damaged_goods",
    DARK_MODE: "dark_mode",
    DASHBOARD: "dashboard",
    DATE: "date",
    DATE_CREATED: "date_created",
    DAYS: "days",
    DECREASE: "decrease",
    DEFAULT_CURRENCY: "default_currency",
    DEFAULT_FOOTER: "default_footer",
    DEFAULT_MEMO: "default_memo",
    DELETE: "delete",
    DELETE_ITEM: "delete_item",
    DELETE_ITEM_X: "delete_item_x",
    DELETE_TIME_SLOT: "delete_time_slot",
    DELIVERED: "delivered",
    DEPARTMENT: "department",
    DEPARTMENTS: "departments",
    DESCRIPTION: "description",
    DISCONNECT: "disconnect",
    DOCUMENTATION: "documentation",
    DOCUMENTS: "documents",
    DOCUMENT_WILL_BE_MADE_AVAILABLE_TO_ALL_EMPLOYEES_IN_YOUR_ORGANIZATION_ON_UPLOAD: "document_will_be_made_available_to_all_employees_in_your_organization_on_upload",
    DONT_HAVE_AN_ACCOUNT: "dont_have_an_account",
    DOWNLOADING_PDF: "downloading_pdf",
    DOWNLOAD_PDF: "download_pdf",
    DRAFT: "draft",
    DRAG_AND_DROP_OR_CLICK_TO_UPLOAD: "drag_and_drop_or_click_to_upload",
    DROP_HERE: "drop_here",
    DUE_DATE: "due_date",
    DUE_DATE_IS_REQUIRED: "due_date_is_required",
    DUE_DATE_MUST_BE_IN_FUTURE: "due_date_must_be_in_future",
    DUE_DATE_TOO_FAR: "due_date_too_far",
    DURATION: "duration",
    EDIT: "edit",
    EDIT_AVAILABILITY: "edit_availability",
    EDIT_EVENT: "edit_event",
    EDIT_LOCATION: "edit_location",
    EDIT_ORDER: "edit_order",
    EDIT_PRODUCT_LINK: "edit_product_link",
    EDIT_SALARY_INFORMATION: "edit_salary_information",
    EDIT_SUPPLIER: "edit_supplier",
    EDIT_TIME_CLOCK_ENTRY: "edit_time_clock_entry",
    EDIT_UNIT_OF_MEASURE: "edit_unit_of_measure",
    EDIT_X: "edit_x",
    EMAIL: "email",
    EMAIL_IS_REQUIRED: "email_is_required",
    EMAIL_TEMPLATES: "email_templates",
    EMAIL_TEMPLATE_1: "email_template_1",
    EMAIL_TEMPLATE_2: "email_template_2",
    EMAIL_TEMPLATE_3: "email_template_3",
    EMAIL_TEMPLATE_4: "email_template_4",
    EMAIL_TEMPLATE_5: "email_template_5",
    EMPLOYEE: "employee",
    EMPLOYEES: "employees",
    EMPLOYEE_ACKNOWLEDGEMENT: "employee_acknowledgement",
    EMPLOYEE_AGREEMENT: "employee_agreement",
    EMPLOYEE_DETAILS: "employee_details",
    EMPLOYEE_ID: "employee_id",
    EMPLOYEE_IN_POSSESSION: "employee_in_possession",
    EMPLOYEE_IS_REQUIRED: "employee_is_required",
    EMPLOYEE_NAME: "employee_name",
    EMPLOYEE_RATE_IS_REQUIRED: "employee_rate_is_required",
    EMPLOYEE_RESPONSE: "employee_response",
    EMPLOYEE_RESPONSES: "employee_responses",
    EMPLOYEE_ROLE_IS_REQUIRED: "employee_role_is_required",
    EMPLOYEE_SUBMISSION: "employee_submission",
    EMPLOYEE_TRAINING: "employee_training",
    EMPLOYEE_USE: "employee_use",
    EMPOYEE_ID_IS_REQUIRED: "employee_id_is_required",
    ENABLE_AUTOMATIC_TAX: "enable_automatic_tax",
    END: "end",
    END_DATE: "end_date",
    END_TIME: "end_time",
    END_TIME_CANNOT_BE_BEFORE_START_TIME: "end_time_cannot_be_before_start_time",
    ENGLISH: "english",
    ENTER_SIX_HEX_CHARS: "enter_six_hex_chars",
    ENTER_YOUR_EMAIL_ADDRESS_TO_RESET_YOUR_PASSWORD: "enter_your_email_address_to_reset_your_password",
    ENTRY_DATE: "entry_date",
    ENTRY_TIME: "entry_time",
    ERROR_ADDING_TIME_CLOCK: "error_adding_time_clock",
    ERROR_LOADING_TIME_CLOCKS: "error_loading_time_clocks",
    ESTIMATED_TAX: "estimated_tax",
    EVENTS: "events",
    EXCEEDS_EXPECTATIONS: "exceeds_expectations",
    EXPECTED_DELIVERY_DATE: "expected_delivery_date",
    FACEBOOK: "facebook",
    FAILED_PAYMENTS_ALERT: "failed_payments_alert",
    FAILED_TO_ADD_EVENT: "failed_to_add_event",
    FAILED_TO_ADD_NOTE: "failed_to_add_note",
    FAILED_TO_ADD_X: "failed_to_add_x",
    FAILED_TO_CREATE_INVOICE: "failed_to_create_invoice",
    FAILED_TO_CREATE_X: "failed_to_create_x",
    FAILED_TO_DELETE_EVENT: "failed_to_delete_event",
    FAILED_TO_DELETE_LOCATION: "failed_to_delete_location",
    FAILED_TO_DELETE_NOTE: "failed_to_delete_note",
    FAILED_TO_DELETE_X: "failed_to_delete_x",
    FAILED_TO_LOAD_DOCUMENT: "failed_to_load_document",
    FAILED_TO_SUBMIT_FEEDBACK_PLEASE_TRY_AGAIN: "failed_to_submit_feedback_please_try_again",
    FAILED_TO_UPDATE_EVENT: "failed_to_update_event",
    FAILED_TO_UPDATE_MANAGERS: "failed_to_update_managers",
    FAILED_TO_UPDATE_ORGANIZATION_LOGO: "failed_to_update_organization_logo",
    FAILED_TO_UPDATE_SUBSCRIPTION: "failed_to_update_subscription",
    FAILED_TO_UPDATE_X: "failed_to_update_x",
    FAILED_TO_VOID_X: "failed_to_void_x",
    FAILED_TO_WITHDRAWAL_X: "failed_to_withdrawal_x",
    FAIR: "fair",
    FAR_BELOW_EXPECTATIONS: "far_below_expectations",
    FEATURES: "features",
    FEATURE_REQUEST: "feature_request",
    FEEDBACK: "feedback",
    FEEDBACK_QUESTION_1: "feedback_question_1",
    FEEDBACK_QUESTION_2: "feedback_question_2",
    FEEDBACK_QUESTION_3: "feedback_question_3",
    FILE_ALREADY_EXISTS: "file_already_exists",
    FILE_SELECTED: "file_selected",
    FILE_TOO_LARGE: "file_too_large",
    FILE_X_ALREADY_EXISTS: "file_x_already_exists",
    FILTER: "filter",
    FINAL_TAX_CALCULATED_BY_STRIPE: "final_tax_calculated_by_stripe",
    FIRST_NAME: "first_name",
    FIRST_NAME_IS_REQUIRED: "first_name_is_required",
    FIXED_AMOUNT: "fixed_amount",
    FORGOT_PASSWORD: "forgot_password",
    FREE_FORM: "free_form",
    FRENCH: "french",
    FULLY_RECEIVED: "fully_received",
    GALLERY: "gallery",
    GENERAL_FEEDBACK: "general_feedback",
    GENERAL_PERFORMANCE: "general_performance",
    GENERATE_DOCUMENT: "generate_document",
    GENERATE_NEW_DOCUMENT: "generate_new_document",
    GENERATE_QUESTIONS: "generate_questions",
    GERMAN: "german",
    GOALS: "goals",
    GOALS_QUESTION_1: "goals_question_1",
    GOALS_QUESTION_2: "goals_question_2",
    GOALS_QUESTION_3: "goals_question_3",
    GOOGLE_CALENDAR: "google_calendar",
    GREATLY_EXCEEDS_EXPECTATIONS: "greatly_exceeds_expectations",
    GUIDES: "guides",
    HELLO_WELCOME_TO_BIZISMART_: "hello_welcome_to_bizismart_",
    HEX_VALUE: "hex_value",
    HIDE_DETAILS: "hide_details",
    HIRE_DATE: "hire_date",
    HOLIDAY: "holiday",
    HOME: "home",
    HOT: "hot",
    HOURLY_RATE: "hourly_rate",
    ID: "id",
    IMAGE: "image",
    IMAGE_LOAD_ERROR: "image_load_error",
    IMAGE_TITLE: "image_title",
    IN: "in",
    INACTIVE: "inactive",
    INACTIVE_EMPLOYEES: "inactive_employees",
    INACTIVE_PRODUCTS: "inactive_products",
    INCLUDED: "included",
    INCLUDE_TAX: "include_tax",
    INCREASE: "increase",
    INCREASED_TO_X_FROM_Y: "increased_to_x_from_y",
    INITIATE_PERFORMANCE_REVIEW: "initiate_performance_review",
    INITIATE_REVIEW: "initiate_review",
    INTEGRATIONS: "integrations",
    INVALID_DATE: "invalid_date",
    INVALID_DUE_DATE: "invalid_due_date",
    INVALID_EMAIL_PLEASE_TRY_AGAIN: "invalid_email_please_try_again",
    INVALID_EMPLOYEE_RATE: "invalid_employee_rate",
    INVALID_PASSWORD_PLEASE_TRY_AGAIN: "invalid_password_please_try_again",
    INVENTORY: "inventory",
    INVENTORY_ORDERS: "inventory_orders",
    INVOICE: "invoice",
    INVOICES: "invoices",
    INVOICES_BY_DAY: "invoices_by_day",
    INVOICES_ISSUED_BY_DAY: "invoices_issued_by_day",
    INVOICES_DUE_IN_NEXT_30_DAYS: "invoices_due_in_next_30_days",
    INVOICE_COUNT: "invoice_count",
    INVOICE_DASHBOARD: "invoice_dashboard",
    INVOICE_DETAILS: "invoice_details",
    INVOICE_ID: "invoice_id",
    INVOICE_INFORMATION: "invoice_information",
    INVOICE_PAYMENT_LINK: "invoice_payment_link",
    INVOICE_PREVIEW_OPENED_NEW_TAB: "invoice_preview_opened_new_tab",
    INVOICE_PRODUCT: "invoice_product",
    INVOICE_SETTINGS: "invoice_settings",
    INVOICE_STATUS_DISTRIBUTION: "invoice_status_distribution",
    ITEM: "item",
    ITEMS_ORDERED: "items_ordered",
    ITEMS_UPDATED: "items_updated",
    ITEM_HISTORY: "item_history",
    ITEM_INFORMATION: "item_information",
    ITEM_NAME: "item_name",
    I_ACKNOWLEDGE_THAT_I_HAVE_REVIEWED_AND_DISCUSSED_THIS_PERFORMANCE_REVIEW_WITH_MY_X: "i_acknowledge_that_i_have_reviewed_and_discussed_this_performance_review_with_my_x",
    JOB_CODE: "job_code",
    JOB_CODES: "job_codes",
    LANDING_PAGE_CAROUSEL_HEADER: "landing_page_carousel_header",
    LANDING_PAGE_TAGLINE_1: "landing_page_tagline_1",
    LANDING_PAGE_TAGLINE_2: "landing_page_tagline_2",
    LAST_30_DAYS: "last_30_days",
    LAST_7_DAYS: "last_7_days",
    LAST_90_DAYS: "last_90_days",
    LAST_MODIFIED: "last_modified",
    LAST_NAME: "last_name",
    LAST_NAME_IS_REQUIRED: "last_name_is_required",
    LAST_ORDER_DATE: "last_order_date",
    LAST_SYNCED_: "last_synced_",
    LAST_YEAR: "last_year",
    LATE_PAYMENT_RATE: "late_payment_rate",
    LEGAL: "legal",
    LIGHT_MODE: "light_mode",
    LIMITED: "limited",
    LIMITED_AVAILABILITY: "limited_availability",
    LIMITED_AVAILABILITY_REQUIRES_EMPLOYEE_AVAILABILITY_BE_SET_FOR_: "limited_availability_requires_employee_availability_be_set_for_",
    LINE_ITEMS: "line_items",
    LINKEDIN: "linkedin",
    LOCATION: "location",
    LOCATIONS: "locations",
    LOG_IN: "log_in",
    LOG_OUT: "log_out",
    MANAGER: "manager",
    MANAGER_ACKNOWLEDGEMENT: "manager_acknowledgement",
    MANAGER_EVALUATION: "manager_evaluation",
    MANAGER_RESPONSE: "manager_response",
    MANAGER_RESPONSES: "manager_responses",
    MANAGER_SUBMISSION: "manager_submission",
    MANAGE_SUBSCRIPTION: "manage_subscription",
    MANAGERS: "managers",
    MANUAL: "manual",
    MANUAL_ADJUSTMENT: "manual_adjustment",
    MANUAL_ENTRY: "manual_entry",
    MARK_AS_PRIVATE: "mark_as_private",
    MAXIMUM_FILE_SIZE_: "maximum_file_size_",
    MEETING_NOTES: "meeting_notes",
    MEETS_EXPECTATIONS: "meets_expectations",
    MESSAGE_TO_OUR_USERS: "message_to_our_users",
    MINIMUM_QUANTITY: "minimum_quantity",
    MINIMUM_QUANTITY_IS_REQUIRED: "minimum_quantity_is_required",
    MODIFY_REVIEW_TEMPLATES: "modify_review_templates",
    MONTHLY: "monthly",
    MONTHLY_REVENUE: "monthly_revenue",
    MULTIPLE_CHOICE: "multiple_choice",
    MY_POSTS: "my_posts",
    NAME: "name",
    NEW: "new",
    NEW_DOCUMENT: "new_document",
    NEW_START_TIME_CANNOT_BE_BEFORE_EXISTING_END_TIME: "new_start_time_cannot_be_before_existing_end_time",
    NEXT: "next",
    NO: "no",
    NONE: "none",
    NOTES: "notes",
    NOT_ASSIGNED: "not_assigned",
    NOT_AVAILABLE: "not_available",
    NOT_YET_SUBMITTED: "not_yet_submitted",
    NO_ACTIVE_SUBSCRIPTION: "no_active_subscription",
    NO_CHANGES_TO_SUBMIT: "no_changes_to_submit",
    NO_CUSTOMER_ASSIGNED: "no_customer_assigned",
    NO_DATA_AVAILABLE: "no_data_available",
    NO_DESCRIPTION: "no_description",
    NO_DOCUMENTS_TO_SHOW: "no_documents_to_show",
    NO_EMPLOYEES_ASSIGNED: "no_employees_assigned",
    NO_END_DATE: "no_end_date",
    NO_ENTRIES_FOR_THIS_DAY: "no_entries_for_this_day",
    NO_EVENTS_TO_DISPLAY: "no_events_to_display",
    NO_HISTORY: "no_history",
    NO_INVOICES_TO_DISPLAY: "no_invoices_to_display",
    NO_ITEMS_ORDERED: "no_items_ordered",
    NO_ITEMS_TO_RECEIVE: "no_items_to_receive",
    NO_MORE_PREMADE_QUESTIONS: "no_more_premade_questions",
    NO_NOTES_TO_DISPLAY: "no_notes_to_display",
    NO_ORDERS_TO_DISPLAY: "no_orders_to_display",
    NO_OUTSTANDING_INVOICES: "no_outstanding_invoices",
    NO_PAYMENT_DATA: "no_payment_data",
    NO_PERFORMANCE_REVIEWS_TO_DISPLAY: "no_performance_reviews_to_display",
    NO_QUESTIONS_SELECTED: "no_questions_selected",
    NO_REPEAT: "no_repeat",
    NO_TEMPLATES_TO_DISPLAY: "no_templates_to_display",
    NO_TIME_CLOCK_DATA_FOR_EMPLOYEE: "no_time_clock_data_for_employee",
    NO_TIME_CLOCK_DATA_TO_DISPLAY: "no_time_clock_data_to_display",
    NON_MANAGERS: "non_managers",
    OK: "ok",
    ONBOARD_WITH_STRIPE: "onboard_with_stripe",
    ON_HAND: "on_hand",
    ON_ORDER: "on_order",
    ONBOARDING_DESCRIPTION_1: "onboarding_description_1",
    ONBOARDING_DESCRIPTION_2: "onboarding_description_2",
    ONBOARDING_HEADER: "onboarding_header",
    OPEN: "open",
    OPTIONAL: "optional",
    ORDER: "order",
    ORDERED: "ordered",
    ORDERS: "orders",
    ORDER_CREATED_SUCCESSFULLY: "order_created_successfully",
    ORDER_DATE: "order_date",
    ORDER_DETAILS: "order_details",
    ORDER_FULLY_RECEIVED: "order_fully_received",
    ORDER_HISTORY: "order_history",
    ORDER_INFORMATION: "order_information",
    ORDER_PARTIALLY_RECEIVED: "order_partially_received",
    ORGANIZATION: "organization",
    ORGANIZATION_ID_MISSING: "organization_id_missing",
    ORGANIZATION_READ_PERMISSION_IS_REQUIRED_FOR_ALL_USERS: "organization_read_permission_is_required_for_all_users",
    OTHER: "other",
    OUT: "out",
    OUTSTANDING_AMOUNT: "outstanding_amount",
    OUTSTANDING_INVOICES: "outstanding_invoices",
    OVERDUE_INVOICES: "overdue_invoices",
    OVERWRITE: "overwrite",
    OWNER: "owner",
    OWNER_IS_REQUIRED_TO_MAINTAIN_FULL_ROLE_PERMISISONS_: "owner_is_required_to_maintain_full_role_permisisons_",
    PAID: "paid",
    PAID_DATE: "paid_date",
    PAID_INVOICES: "paid_invoices",
    PAID_LATE: "paid_late",
    PAID_ON_TIME: "paid_on_time",
    PASSWORD: "password",
    PASSWORDS_DO_NOT_MATCH: "passwords_do_not_match",
    PASSWORD_CANNOT_EXCEED_4096_CHARACTERS: "password_cannot_exceed_4096_characters",
    PASSWORD_IS_REQUIRED: "password_is_required",
    PASSWORD_MUST_BE_AT_LEAST_8_CHARACTERS: "password_must_be_at_least_8_characters",
    PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_LOWERCASE_LETTER: "password_must_contain_at_least_one_lowercase_letter",
    PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_NUMBER: "password_must_contain_at_least_one_number",
    PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_SPECIAL_CHARACTER: "password_must_contain_at_least_one_special_character",
    PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_UPPERCASE_LETTER: "password_must_contain_at_least_one_uppercase_letter",
    PASSWORD_RESET_EMAIL_SENT: "password_reset_email_sent",
    PAYMENTS: "payments",
    PAYMENT_METHODS: "payment_methods",
    PAYMENT_RATE: "payment_rate",
    PAYMENT_SETTINGS: "payment_settings",
    PAYMENT_STATUS: "payment_status",
    PAYMENT_STATUS_DISTRIBUTION: "payment_status_distribution",
    PAYMENT_TERMS: "payment_terms",
    PAYMENT_TIMELINE: "payment_timeline",
    PENDING: "pending",
    PENDING_PAYMENT: "pending_payment",
    PERCENTAGE: "percentage",
    PERFORMANCE: "performance",
    PERFORMANCE_QUESTION_1: "performance_question_1",
    PERFORMANCE_QUESTION_2: "performance_question_2",
    PERFORMANCE_QUESTION_3: "performance_question_3",
    PERFORMANCE_QUESTION_4: "performance_question_4",
    PERFORMANCE_QUESTION_5: "performance_question_5",
    PERFORMANCE_REVIEW: "performance_review",
    PERFORMANCE_REVIEWS: "performance_reviews",
    PERFORMANCE_REVIEW_REPORT: "performance_review_report",
    PERMISSION_REQUEST_SENT_TO_MANAGER: "permission_request_sent_to_manager",
    PHONE: "phone",
    PHONE_NUMBER_IS_REQUIRED: "phone_number_is_required",
    PLEASE_CONTACT_YOUR_ADMINISTRATOR_TO_REACTIVATE_YOUR_SUBSCRIPTION: "please_contact_your_administrator_to_reactivate_your_subscription",
    PLEASE_CROP_THE_IMAGE: "please_crop_the_image",
    PLEASE_ENTER_A_VALID_ZIP_CODE: "please_enter_a_valid_zip_code",
    PLEASE_ENTER_YOUR_EMAIL_ADDRESS: "please_enter_your_email_address",
    PLEASE_ENTER_VALID_HEX_COLORS: "please_enter_valid_hex_colors",
    PLEASE_FILL_OUT_THIS_FIELD: "please_fill_out_this_field",
    PLEASE_PROVIDE_KEY_DETAILS_FOR_YOUR_: "please_provide_key_details_for_your_",
    PLEASE_REACTIVATE_YOUR_SUBSCRIPTION_TO_CONTINUE: "please_reactivate_your_subscription_to_continue",
    PLEASE_SELECT_A_CUSTOMER: "please_select_a_customer",
    PLEASE_SELECT_A_FILE: "please_select_a_file",
    PLEASE_SELECT_A_FILE_AND_ENTER_A_TITLE: "please_select_a_file_and_enter_a_title",
    PLEASE_SELECT_EMPLOYEE: "please_select_employee",
    PLEASE_SELECT_FEEDBACK_TYPE: "please_select_a_type_of_feedback",
    PLEASE_WAIT_WHILE_WE_COMPLETE_YOUR_REQUEST: "please_wait_while_we_complete_your_request",
    PLEASE_WAIT_WHILE_WE_CREATE_YOUR_ORGANIZATION: "please_wait_while_we_create_your_organization",
    PLEASE_WAIT_WHILE_WE_SETUP_YOUR_SUBSCRIPTION: "please_wait_while_we_setup_your_subscription",
    PLEASE_WAIT_WHILE_WE_UPDATE_YOUR_INFORMATION: "please_wait_while_we_update_your_information",
    POINT_OF_SALE: "point_of_sale",
    POINT_OF_SALE_PRODUCT: "point_of_sale_product",
    POOR: "poor",
    PORTUGUESE: "portuguese",
    POSSESSION: "possession",
    POST_A_REPLY: "post_a_reply",
    POSTED_BY: "posted_by",
    POTENTIAL_REVENUE: "potential_revenue",
    PREMADE_QUESTION: "premade_question",
    PREMADE_QUESTIONS: "premade_questions",
    PREVIEW: "preview",
    PREVIOUS: "previous",
    PRICE: "price",
    PRICE_IS_REQUIRED: "price_is_required",
    PRICE_PER_UNIT: "price_per_unit",
    PRIMARY_COLOR: "primary_color",
    PRINT_QR_CODE: "print_qr_code",
    PRINT_QR_CODES: "print_qr_codes",
    PRINT_REVIEW: "print_review",
    PRINT_SELECTED_QR_CODES: "print_selected_qr_codes",
    PRINT_X_SELECTED_QR_CODES: "print_x_selected_qr_codes",
    PRIVACY_CHOICES: "privacy_choices",
    PRIVACY_CHOICES_ACCESS_INFO_CONTENT: "privacy_choices_access_info_content",
    PRIVACY_CHOICES_ACCESS_INFO_SECTION: "privacy_choices_access_info_section",
    PRIVACY_CHOICES_COMMUNICATIONS_SECTION: "privacy_choices_communications_section",
    PRIVACY_CHOICES_CONSENT_CONTENT: "privacy_choices_consent_content",
    PRIVACY_CHOICES_CONSENT_SECTION: "privacy_choices_consent_section",
    PRIVACY_CHOICES_COOKIES_CONTENT: "privacy_choices_cookies_content",
    PRIVACY_CHOICES_COOKIES_SECTION: "privacy_choices_cookies_section",
    PRIVACY_CHOICES_DATA_PORTABILITY_CONTENT: "privacy_choices_data_portability_content",
    PRIVACY_CHOICES_DATA_PORTABILITY_SECTION: "privacy_choices_data_portability_section",
    PRIVACY_CHOICES_DATA_RETENTION_CONTENT: "privacy_choices_data_retention_content",
    PRIVACY_CHOICES_DELETE_ACCOUNT_CONTENT: "privacy_choices_delete_account_content",
    PRIVACY_CHOICES_DELETE_ACCOUNT_SECTION: "privacy_choices_delete_account_section",
    PRIVACY_CHOICES_DELETE_PROCESS_CONTENT: "privacy_choices_delete_process_content",
    PRIVACY_CHOICES_LAST_UPDATED: "privacy_choices_last_updated",
    PRIVACY_CHOICES_MARKETING_CONTENT: "privacy_choices_marketing_content",
    PRIVACY_CHOICES_PROCESSING_CONTENT: "privacy_choices_processing_content",
    PRIVACY_CHOICES_PROCESSING_SECTION: "privacy_choices_processing_section",
    PRIVACY_CHOICES_TITLE: "privacy_choices_title",
    PRIVACY_CHOICES_TRANSACTIONAL_CONTENT: "privacy_choices_transactional_content",
    PRIVACY_CHOICES_UPDATE_INFO_CONTENT: "privacy_choices_update_info_content",
    PRIVACY_POLICY: "privacy_policy",
    PRIVACY_POLICY_CONTACT_EMAIL: "privacy_policy_contact_email",
    PRIVACY_POLICY_CONTACT_PHONE: "privacy_policy_contact_phone",
    PRIVACY_POLICY_CONTACT_SECTION: "privacy_policy_contact_section",
    PRIVACY_POLICY_DATA_RIGHTS_CONTENT: "privacy_policy_data_rights_content",
    PRIVACY_POLICY_DATA_RIGHTS_SECTION: "privacy_policy_data_rights_section",
    PRIVACY_POLICY_DATA_SECURITY_CONTENT: "privacy_policy_data_security_content",
    PRIVACY_POLICY_DATA_SECURITY_SECTION: "privacy_policy_data_security_section",
    PRIVACY_POLICY_EFFECTIVE_DATE: "privacy_policy_effective_date",
    PRIVACY_POLICY_INTRO: "privacy_policy_intro",
    PRIVACY_POLICY_PERSONAL_INFO_CONTENT: "privacy_policy_personal_info_content",
    PRIVACY_POLICY_PERSONAL_INFO_SECTION: "privacy_policy_personal_info_section",
    PRIVACY_POLICY_SHARING_CONTENT: "privacy_policy_sharing_content",
    PRIVACY_POLICY_SHARING_SECTION: "privacy_policy_sharing_section",
    PRIVACY_POLICY_THIRD_PARTY_CONTENT: "privacy_policy_third_party_content",
    PRIVACY_POLICY_THIRD_PARTY_SECTION: "privacy_policy_third_party_section",
    PRIVACY_POLICY_USAGE_CONTENT: "privacy_policy_usage_content",
    PRIVACY_POLICY_USAGE_SECTION: "privacy_policy_usage_section",
    PRIVACY_POLICY_USE_INFO_CONTENT: "privacy_policy_use_info_content",
    PRIVACY_POLICY_USE_INFO_SECTION: "privacy_policy_use_info_section",
    PRIVATE: "private",
    PROCESSING: "processing",
    PROCESSING_PAYMENT_INFORMATION: "processing_payment_information",
    PROCESSING_YOUR_PAYMENT: "processing_your_payment",
    PRODUCT: "product",
    PRODUCTS: "products",
    PRODUCT_CATEGORY_NAME_REQUIRED: "product_category_name_required",
    PRODUCT_LINK: "product_link",
    PRODUCT_NAME_IS_REQUIRED: "product_name_is_required",
    PRODUCT_PAGE: "product_page",
    PRODUCT_SKU: "product_sku",
    PROFILE: "profile",
    PROHIBITED_BUSINESSES: "prohibited_businesses",
    PROHIBITED_BUSINESSES_ADULT_ITEMS: "prohibited_businesses_adult_items",
    PROHIBITED_BUSINESSES_ADULT_SECTION: "prohibited_businesses_adult_section",
    PROHIBITED_BUSINESSES_ENFORCEMENT_CONTENT: "prohibited_businesses_enforcement_content",
    PROHIBITED_BUSINESSES_ENFORCEMENT_SECTION: "prohibited_businesses_enforcement_section",
    PROHIBITED_BUSINESSES_FINANCIAL_ITEMS: "prohibited_businesses_financial_items",
    PROHIBITED_BUSINESSES_FINANCIAL_SECTION: "prohibited_businesses_financial_section",
    PROHIBITED_BUSINESSES_GAMBLING_ITEMS: "prohibited_businesses_gambling_items",
    PROHIBITED_BUSINESSES_GAMBLING_SECTION: "prohibited_businesses_gambling_section",
    PROHIBITED_BUSINESSES_HARMFUL_ITEMS: "prohibited_businesses_harmful_items",
    PROHIBITED_BUSINESSES_HARMFUL_SECTION: "prohibited_businesses_harmful_section",
    PROHIBITED_BUSINESSES_HIGH_RISK_ITEMS: "prohibited_businesses_high_risk_items",
    PROHIBITED_BUSINESSES_HIGH_RISK_SECTION: "prohibited_businesses_high_risk_section",
    PROHIBITED_BUSINESSES_ILLEGAL_ITEMS: "prohibited_businesses_illegal_items",
    PROHIBITED_BUSINESSES_ILLEGAL_SECTION: "prohibited_businesses_illegal_section",
    PROHIBITED_BUSINESSES_INTRO: "prohibited_businesses_intro",
    PROHIBITED_BUSINESSES_IP_ITEMS: "prohibited_businesses_ip_items",
    PROHIBITED_BUSINESSES_IP_SECTION: "prohibited_businesses_ip_section",
    PROHIBITED_BUSINESSES_LAST_UPDATED: "prohibited_businesses_last_updated",
    PROHIBITED_BUSINESSES_MONEY_LAUNDERING_ITEMS: "prohibited_businesses_money_laundering_items",
    PROHIBITED_BUSINESSES_MONEY_LAUNDERING_SECTION: "prohibited_businesses_money_laundering_section",
    PROHIBITED_BUSINESSES_ONLINE_ITEMS: "prohibited_businesses_online_items",
    PROHIBITED_BUSINESSES_ONLINE_SECTION: "prohibited_businesses_online_section",
    PROHIBITED_BUSINESSES_OTHER_ITEMS: "prohibited_businesses_other_items",
    PROHIBITED_BUSINESSES_OTHER_SECTION: "prohibited_businesses_other_section",
    PROHIBITED_BUSINESSES_PRIVACY_ITEMS: "prohibited_businesses_privacy_items",
    PROHIBITED_BUSINESSES_PRIVACY_SECTION: "prohibited_businesses_privacy_section",
    PROHIBITED_BUSINESSES_REGULATED_ITEMS: "prohibited_businesses_regulated_items",
    PROHIBITED_BUSINESSES_REGULATED_SECTION: "prohibited_businesses_regulated_section",
    PROHIBITED_BUSINESSES_RESPONSIBILITIES_CONTENT: "prohibited_businesses_responsibilities_content",
    PROHIBITED_BUSINESSES_RESPONSIBILITIES_SECTION: "prohibited_businesses_responsibilities_section",
    PROHIBITED_BUSINESSES_TITLE: "prohibited_businesses_title",
    PROHIBITED_BUSINESSES_UNFAIR_ITEMS: "prohibited_businesses_unfair_items",
    PROHIBITED_BUSINESSES_UNFAIR_SECTION: "prohibited_businesses_unfair_section",
    PROHIBITED_BUSINESSES_VIOLENCE_ITEMS: "prohibited_businesses_violence_items",
    PROHIBITED_BUSINESSES_VIOLENCE_SECTION: "prohibited_businesses_violence_section",
    PUBLIC: "public",
    PUNCH: "punch",
    PURCHASE_DATE: "purchase_date",
    PURCHASE_ORDER: "purchase_order",
    Q1: "q1",
    Q2: "q2",
    Q3: "q3",
    Q4: "q4",
    QUANTITY: "quantity",
    QUANTITY_CHANGE: "quantity_change",
    QUANTITY_ON_HAND: "quantity_on_hand",
    QUANTITY_ON_HAND_IS_REQUIRED: "quantity_on_hand_is_required",
    QUANTITY_ON_HAND_HAS_REACHED_OR_SURPASSED_YOUR_REORDER_QUANTITY: "quantity_on_hand_has_reached_or_surpassed_your_reorder_quantity",
    QUANTITY_ORDERED: "quantity_ordered",
    QUANTITY_RECEIVED: "quantity_received",
    QUESTION_TYPE: "question_type",
    QUOTE_ESTIMATE: "quote_estimate",
    RATE: "rate",
    READ: "read",
    READ_ALL_REVIEWS: "read_all_reviews",
    READ_ALL_TIME_CLOCKS: "read_all_time_clocks",
    READ_AND_WRITE_ALL_REVIEWS: "read_and_write_all_reviews",
    READ_AND_WRITE_ALL_TIME_CLOCKS: "read_and_write_all_time_clocks",
    READ_AND_WRITE_OWN_REVIEW: "read_and_write_own_review",
    READ_AND_WRITE_REVIEWS_FOR_MANAGED_EMPLOYEES: "read_and_write_reviews_for_managed_employees",
    REASON: "reason",
    REASON_FOR_ADJUSTMENT: "reason_for_adjustment",
    REASON_FOR_EDIT: "reason_for_edit",
    REASON_FOR_WITHDRAWAL: "reason_for_withdrawal",
    REASON_REQUIRED: "reason_required",
    RECEIPT_URL: "receipt_url",
    RECEIVED: "received",
    RECEIVE_ORDER: "receive_order",
    RECEIVE_ORDER_NUMBER: "receive_order_number",
    RECEIVE_QUANTITY: "receive_quantity",
    RECENTLY: "recently",
    RECURRENCE: "recurrence",
    RECURRING_EVENT: "recurring_event",
    REDUCED_TO_X_FROM_Y: "reduced_to_x_from_y",
    REFUND: "refund",
    REFUNDED: "refunded",
    REFUND_DETAILS: "refund_details",
    REJECT: "reject",
    REMAINING: "remaining",
    REMOVE_AND_TRY_AGAIN: "remove_and_try_again",
    REMOVE_TAX_REGISTRATION: "remove_tax_registration",
    REORDER_QUANTITY: "reorder_quantity",
    REORDER_QUANTITY_IS_REQUIRED: "reorder_quantity_is_required",
    REPEAT: "repeat",
    REPEAT_END_DATE: "repeat_end_date",
    REPEAT_EVERY: "repeat_every",
    REPLY: "reply",
    REPORT_A_BUG: "report_a_bug",
    REPORT_FEEDBACK: "report_feedback",
    REQUEST_EDIT_PERMISSION: "request_edit_permission",
    RESET_PASSWORD: "reset_password",
    RESOURCES: "resources",
    RETIRED: "retired",
    REVENUE: "revenue",
    REVIEW_ACKNOWLEDGEMENT: "review_acknowledgement",
    REVIEW_CYCLE: "review_cycle",
    REVIEW_CYCLE_IS_REQUIRED: "review_cycle_is_required",
    REVIEW_DETAILS: "review_details",
    REVIEW_TEMPLATE: "review_template",
    REVIEW_TEMPLATES: "review_templates",
    REVIEW_TEMPLATE_IS_REQUIRED: "review_template_is_required",
    REVIEW_TIME_CLOCKS: "review_time_clocks",
    REVIEW_TIME_CLOCK_SUBMISSIONS: "review_time_clock_submissions",
    REVIEW_TIME_SHEETS: "review_time_sheets",
    RISING: "rising",
    ROLE: "role",
    ROLES: "roles",
    ROLE_NAME: "role_name",
    SAVE: "save",
    SAVE_AS_COPY: "save_as_copy",
    SAVE_AS_DOC: "save_as_doc",
    SAVE_DOCUMENT: "save_document",
    SAVED: "saved",
    SAVING_YOUR_PROFILE: "saving_your_profile",
    SCHEDULE: "schedule",
    SCHEDULED_CUSTOMER: "scheduled_customer",
    SCHEDULED_EMPLOYEES: "scheduled_employees",
    SCRAP: "scrap",
    SEARCH: "search",
    SEARCH_POSTS: "search_posts",
    SECONDARY_COLOR: "secondary_color",
    SECTION: "section",
    SELECTED_QUESTIONS: "selected_questions",
    SELECT_ALL_PERMISSIONS: "select_all_permissions",
    SELECT_A_PREMADE_QUESTION: "select_a_premade_question",
    SELECT_CUSTOMER: "select_customer",
    SELECT_FEEDBACK_TYPE: "select_feedback_type",
    SELECT_FILE: "select_file",
    SELECT_FOCUS_AREAS: "select_focus_areas",
    SELECT_ITEMS_TO_PRINT: "select_items_to_print",
    SELECT_JOB_CODE: "select_job_code",
    SELECT_PRODUCT: "select_product",
    SELECT_WEEK: "select_week",
    SELF_EVALUATION: "self_evaluation",
    SENDING: "sending",
    SENDING_INVOICE: "sending_invoice",
    SEND_AGAIN: "send_again",
    SEND_INVOICE: "send_invoice",
    SEND_REQUEST: "send_request",
    SEND_RESET_EMAIL: "send_reset_email",
    SERIAL_NUMBER: "serial_number",
    SERVICE_AGREEMENT: "service_agreement",
    SETTING_UP_YOUR_ORGANIZATION: "setting_up_your_organization",
    SETTINGS: "settings",
    SHIFT_DURATION_EXCEEDS_24_HOURS: "shift_duration_exceeds_24_hours",
    SHOW_ALL: "show_all",
    SHOW_ALL_TAX_CODES: "show_all_tax_codes",
    SHOW_DETAILS: "show_details",
    SIGN_UP: "sign_up",
    SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN: "something_went_wrong_please_try_again",
    SORT: "sort",
    SPANISH: "spanish",
    SPECIFY_DOCUMENT_TYPE: "specify_document_type",
    START: "start",
    START_A_NEW_DOCUMENT: "start_a_new_document",
    START_DATE: "start_date",
    START_TIME: "start_time",
    START_TIME_CANNOT_BE_AFTER_END_TIME: "start_time_cannot_be_after_end_time",
    STATE: "state",
    STATEMENT_DESCRIPTOR: "statement_descriptor",
    STATEMENT_DESCRIPTOR_HELP: "statement_descriptor_help",
    STATE_IS_REQUIRED: "state_is_required",
    STATUS: "status",
    STILL_CLOCKED_IN: "still_clocked_in",
    SUBMIT: "submit",
    SUBMITTED_ON: "submitted_on",
    SUBSCRIBED: "subscribed",
    SUBSCRIPTION: "subscription",
    SUBSCRIPTIONS_USED: "subscriptions_used",
    SUBSCRIPTION_DETAILS: "subscription_details",
    SUB_TOTAL: "sub_total",
    SUCCESS: "success",
    SUCCESSFULLY_ADDED_EVENT: "successfully_added_event",
    SUCCESSFULLY_ADDED_NOTE: "successfully_added_note",
    SUCCESSFULLY_ADDED_SUBSCRIPTION: "successfully_added_subscription",
    SUCCESSFULLY_ADDED_X: "successfully_added_x",
    SUCCESSFULLY_CREATED_INVOICE: "successfully_created_invoice",
    SUCCESSFULLY_CREATED_X: "successfully_created_x",
    SUCCESSFULLY_DELETED_EVENT: "successfully_deleted_event",
    SUCCESSFULLY_DELETED_LOCATION: "successfully_deleted_location",
    SUCCESSFULLY_DELETED_NOTE: "successfully_deleted_note",
    SUCCESSFULLY_DELETED_ORDER: "successfully_deleted_order",
    SUCCESSFULLY_DELETED_ROLE: "successfully_deleted_role",
    SUCCESSFULLY_DELETED_SUPPLIER: "successfully_deleted_supplier",
    SUCCESSFULLY_DELETED_X: "successfully_deleted_x",
    SUCCESSFULLY_REFUNDED_INVOICE: "successfully_refunded_invoice",
    SUCCESSFULLY_REMOVED_SUBSCRIPTION: "successfully_removed_subscription",
    SUCCESSFULLY_UPDATED_EVENT: "successfully_updated_event",
    SUCCESSFULLY_UPDATED_ORGANIZATION_LOGO: "successfully_updated_organization_logo",
    SUCCESSFULLY_UPDATED_ROLE_PERMISSIONS: "successfully_updated_role_permissions",
    SUCCESSFULLY_UPDATED_X: "successfully_updated_x",
    SUCCESSFULLY_VOIDED_X: "successfully_voided_x",
    SUCCESSFULLY_WITHDREW_X: "successfully_withdrew_x",
    SUGGESTED_DOCUMENTS: "suggested_documents",
    SUPPLIER: "supplier",
    SUPPLIERS: "suppliers",
    SUPPLIER_INFORMATION: "supplier_information",
    SUPPLIER_NAME: "supplier_name",
    SUPPLIER_NAME_IS_REQUIRED: "supplier_name_is_required",
    SUPPORT: "support",
    SUPPORT_CENTER: "support_center",
    SWITCH_TO_MANAGER_EVALUATION: "switch_to_manager_evaluation",
    SWITCH_TO_SELF_EVALUATION: "switch_to_self_evaluation",
    SWITCH_WILL_BE_AVAILABLE_AFTER_EMPLOYEE_SUBMITS_THEIR_REVIEW: "switch_will_be_available_after_employee_submits_their_review",
    SWITCH_WILL_BE_AVAILABLE_AFTER_MANAGER_SUBMITS_THEIR_REVIEW: "switch_will_be_available_after_manager_submits_their_review",
    SYNC: "sync",
    SYNCING: "syncing",
    SYNC_GOOGLE_CALENDAR: "sync_google_calendar",
    TAP_TO_SELECT_IMAGE: "tap_to_select_image",
    TAX: "tax",
    TAX_AMOUNT: "tax_amount",
    TAX_BEHAVIOR: "tax_behavior",
    TAX_CALCULATION_AUTOMATIC: "tax_calculation_automatic",
    TAX_CALCULATION_MANUAL: "tax_calculation_manual",
    TAX_CALCULATION_METHOD: "tax_calculation_method",
    TAX_EXCLUSIVE: "tax_exclusive",
    TAX_ID_COLLECTION: "tax_id_collection",
    TAX_INCLUSIVE: "tax_included",
    TAX_LOCATION_SETTINGS: "tax_location_settings",
    TAX_PERCENTAGE: "tax_percentage",
    TAX_RATE_AUTOMATIC: "tax_rate_automatic",
    TAX_RATE_MANUAL: "tax_rate_manual",
    TAX_REGISTRATION_COUNTRY: "tax_registration_country",
    TAX_REGISTRATION_NUMBER: "tax_registration_number",
    TAX_REGISTRATION_REQUIRED: "tax_registration_required",
    TAX_REGISTRATION_STATE: "tax_registration_state",
    TAX_REGISTRATION_TYPE: "tax_registration_type",
    TAX_SETTINGS: "tax_settings",
    TAX_SETUP_DESCRIPTION: "tax_setup_description",
    TAX_SETUP_ERROR: "tax_setup_error",
    TAX_SETUP_GUIDE: "tax_setup_guide",
    TAX_SETUP_STEP_1: "tax_setup_step_1",
    TAX_SETUP_STEP_2: "tax_setup_step_2",
    TAX_SETUP_STEP_3: "tax_setup_step_3",
    TAX_SETUP_STEP_4: "tax_setup_step_4",
    TAX_SETUP_SUCCESS: "tax_setup_success",
    TAX_TYPE: "tax_type",
    TEMPLATES: "templates",
    TEMPLATE_NAME: "template_name",
    TEMPLATE_NAME_IS_REQUIRED: "template_name_is_required",
    TERMINATION_DATE: "termination_date",
    TERMINATION_DATE_IS_REQUIRED: "termination_date_is_required",
    TERMS_OF_SERVICE: "terms_of_service",
    TERMS_OF_SERVICE_CONFIDENTIALITY_CONTENT: "terms_of_service_confidentiality_content",
    TERMS_OF_SERVICE_CONFIDENTIALITY_SECTION: "terms_of_service_confidentiality_section",
    TERMS_OF_SERVICE_CONTACT_EMAIL: "terms_of_service_contact_email",
    TERMS_OF_SERVICE_CONTACT_PHONE: "terms_of_service_contact_phone",
    TERMS_OF_SERVICE_CONTACT_SECTION: "terms_of_service_contact_section",
    TERMS_OF_SERVICE_DESCRIPTION_CONTENT: "terms_of_service_description_content",
    TERMS_OF_SERVICE_DESCRIPTION_SECTION: "terms_of_service_description_section",
    TERMS_OF_SERVICE_DISCLAIMERS_CONTENT: "terms_of_service_disclaimers_content",
    TERMS_OF_SERVICE_DISCLAIMERS_SECTION: "terms_of_service_disclaimers_section",
    TERMS_OF_SERVICE_EFFECTIVE_DATE: "terms_of_service_effective_date",
    TERMS_OF_SERVICE_GOVERNING_LAW_CONTENT: "terms_of_service_governing_law_content",
    TERMS_OF_SERVICE_GOVERNING_LAW_SECTION: "terms_of_service_governing_law_section",
    TERMS_OF_SERVICE_INDEMNIFICATION_CONTENT: "terms_of_service_indemnification_content",
    TERMS_OF_SERVICE_INDEMNIFICATION_SECTION: "terms_of_service_indemnification_section",
    TERMS_OF_SERVICE_INTELLECTUAL_PROPERTY_CONTENT: "terms_of_service_intellectual_property_content",
    TERMS_OF_SERVICE_INTELLECTUAL_PROPERTY_SECTION: "terms_of_service_intellectual_property_section",
    TERMS_OF_SERVICE_INTRO_CONTENT: "terms_of_service_intro_content",
    TERMS_OF_SERVICE_INTRO_SECTION: "terms_of_service_intro_section",
    TERMS_OF_SERVICE_SUBSCRIPTION_CONTENT: "terms_of_service_subscription_content",
    TERMS_OF_SERVICE_SUBSCRIPTION_SECTION: "terms_of_service_subscription_section",
    TERMS_OF_SERVICE_TERMINATION_CONTENT: "terms_of_service_termination_content",
    TERMS_OF_SERVICE_TERMINATION_SECTION: "terms_of_service_termination_section",
    TERMS_OF_SERVICE_USER_ACCOUNTS_CONTENT: "terms_of_service_user_accounts_content",
    TERMS_OF_SERVICE_USER_ACCOUNTS_SECTION: "terms_of_service_user_accounts_section",
    TERMS_OF_SERVICE_USER_CONDUCT_CONTENT: "terms_of_service_user_conduct_content",
    TERMS_OF_SERVICE_USER_CONDUCT_SECTION: "terms_of_service_user_conduct_section",
    THANK_YOU_FOR_YOUR_FEEDBACK: "thank_you_for_your_feedback",
    THEME: "theme",
    THE_PROPOSED_EVENT_ON_X_FROM_Y_TO_Z_HAS_CONFLICTS: "the_proposed_event_on_x_from_y_to_z_has_conflicts",
    THIS_INVOICE_HAS_BEEN_SENT: "this_invoice_has_been_sent",
    THIS_ITEM_WAS_ARCHIVED_ON_X_BY: "this_item_was_archived_on_x_by",
    THIS_REVIEW_HAS_BEEN_SUBMITTED_AND_IS_LOCKED_: "this_review_has_been_submitted_and_is_locked_",
    TIME_AGO: "time_ago",
    TIME_CLOCK: "time_clock",
    TIME_CLOCK_ENTRY_ADDED: "time_clock_entry_added",
    TIME_CONFLICT: "time_conflict",
    TIME_IN: "time_in",
    TIME_MANAGEMENT: "time_management",
    TIME_OUT: "time_out",
    TIME_SHEET: "time_sheet",
    TIME_SLOT: "time_slot",
    TIME_TRACKING: "time_tracking",
    TITLE: "title",
    TITLE_IS_REQUIRED: "title_is_required",
    TOP: "top",
    TOPIC: "topic",
    TOPIC_IS_REQUIRED: "topic_is_required",
    TOP_CUSTOMERS: "top_customers",
    TOP_OUTSTANDING_BY_CUSTOMER: "top_outstanding_by_customer",
    TOTAL: "total",
    TOTAL_COST: "total_cost",
    TOTAL_HOURS: "total_hours",
    TOTAL_INVOICES: "total_invoices",
    TOTAL_PRICE: "total_price",
    TOTAL_REVENUE: "total_revenue",
    TRIALING: "trialing",
    TRY_BIZISMART_FREE_FOR_30_DAYS: "try_bizismart_free_for_30_days_no_strings_attached",
    TWITTER: "twitter",
    TYPE: "type",
    TYPE_OF_EDIT: "type_of_edit",
    TYPE_YOUR_MESSAGE: "type_your_message",
    UNASSIGNED: "unassigned",
    UNAVAILABLE: "unavailable",
    UNIT_OF_MEASURE: "unit_of_measure",
    UNIT_OF_MEASURE_IS_REQUIRED: "unit_of_measure_is_required",
    UNIT_PRICE: "unit_price",
    UNKNOWN: "unknown",
    UNKNOWN_CUSTOMER: "unknown_customer",
    UNKNOWN_EMPLOYEE: "unknown_employee",
    UNMARK_AS_PRIVATE: "unmark_as_private",
    UPCOMING_EVENTS: "upcoming_events",
    UPDATED_BY: "updated_by",
    UPLOADING: "uploading",
    UPLOAD_FILE: "upload_file",
    UPLOAD_IMAGE: "upload_image",
    UPLOAD_LOGO: "upload_logo",
    URL: "url",
    USED: "used",
    USER_MUST_BE_IN_AN_ACTIVE_STATE_TO_ADD_A_SUBSCRIPTION: "user_must_be_in_an_active_state_to_add_a_subscription",
    VIEW_DETAILS: "view_details",
    VIEW_RECEIPT: "view_receipt",
    VIEW_SALARY_INFORMATION: "view_salary_information",
    VOID: "void",
    WEEKLY: "weekly",
    WEEKLY_TOTAL: "weekly_total",
    WEEK_OF: "week_of",
    WIRE_TRANSFER: "wire_transfer",
    WITHDRAWAL: "withdrawal",
    WITHDRAWAL_INVENTORY: "withdrawal_inventory",
    WORK_AND_CONTACT_INFORMATION: "work_and_contact_information",
    WRITE: "write",
    X_DOCUMENTS: "x_documents",
    YEARLY: "yearly",
    YES: "yes",
    YOUR_RESPONSE_HERE: "your_response_here",
    YOUR_SUBSCRIPTION_IS_INACTIVE: "your_subscription_is_inactive",
    YOUR_SUBSCRIPTION_IS_INACTIVE_PLEASE_CONTACT_YOUR_ADMINISTRATOR_TO_REACTIVATE: "your_subscription_is_inactive_please_contact_your_administrator_to_reactivate",
    YOUR_WEEKLY_TIME_CLOCK_ENTRIES: "your_weekly_time_clock_entries",
    YOU_CANNOT_PERFORM_YOUR_REVIEW_UNTIL_THE_EMPLOYEE_COMPLETES_THEIR_SELF_EVALUATION: "you_cannot_perform_your_review_until_the_employee_completes_their_self_evaluation",
    YOU_HAVE_USED_ALL_OF_YOUR_AVAILABLE_SUBSCRIPTION_SEATS: "you_have_used_all_of_your_available_subscription_seats",
    ZIP_CODE: "zip_code",
    ZIP_CODE_IS_REQUIRED: "zip_code_is_required",
    SYSTEM_REQUIREMENTS: "system_requirements",
    TABLES: "tables",
    TAX_CODE: "tax_code",
    TAX_CODES: "tax_codes",
    TAX_ADDED: "tax_added",
    TAX_ADDED_TO_PRICE: "tax_added_to_price",
    TAX_BEHAVIOR: "tax_behavior",
    TAX_DETERMINES_HOW_TAXED: "tax_determines_how_taxed",
    TAX_FINAL_PRICE_INCLUDES: "tax_final_price_includes",
    TAX_INCLUDED: "tax_included",
    TAX_SETTINGS: "tax_settings",
    TAX_CODE_DISABLED_WITH_INCLUSIVE: "tax_code_disabled_with_inclusive"
};
